import { Box } from "@twilio-paste/core/box";
import {
  WiseOwlBlock,
  WiseOwlBlockDisplayType,
  WiseOwlBlockType,
} from "@twiliointernal/org/twilio/e2-commons/shared/definitions";
import { ReactElement } from "react";
import {
  MessageRenderer,
  ButtonGroup,
  LinkGroup,
  LiveChat,
  PromptSuggestionGroup,
  ToolCallRenderer,
  ToolCallStatusLine,
} from "./sub";
import IntelligentDiscoveryAssistantHome from "../intelligentDiscoveryAssistant/IntelligentDiscoveryHome";
import LoginCTARenderer from "./sub/LoginCTARenderer";
import TableRenderer from "./sub/TableRenderer";

export interface BlockRendererProps {
  blocks: WiseOwlBlock[];
}

const getRendererForBlock = (block: WiseOwlBlock) => {
  switch (block.type) {
    case WiseOwlBlockType.Message:
      return <MessageRenderer block={block} />;
    case WiseOwlBlockType.ButtonGroup:
      return <ButtonGroup block={block} />;
    case WiseOwlBlockType.LinkGroup:
      return <LinkGroup block={block} />;
    case WiseOwlBlockType.PromptSuggestionGroup:
      return <PromptSuggestionGroup block={block} />;
    case WiseOwlBlockType.ToolCall:
      return <ToolCallRenderer block={block} />;
    case WiseOwlBlockType.ToolCallStatusLine:
      return <ToolCallStatusLine block={block} />;
    case WiseOwlBlockType.IntelligentDiscoveryHome:
      return <IntelligentDiscoveryAssistantHome block={block} />;
    case WiseOwlBlockType.LiveChat:
      return <LiveChat block={block} />;
    case WiseOwlBlockType.LoginCTA:
      return <LoginCTARenderer block={block} />;
    case WiseOwlBlockType.TableBlock:
      return <TableRenderer block={block} />;
    // stub
    // TODO: Update with IDA block work
    case WiseOwlBlockType.SubmitTicketForm:
      return <></>;
  }
};

const BlockRenderer = ({ blocks }: BlockRendererProps): ReactElement => {
  return (
    <Box>
      {blocks.map((block, index) => {
        /**
         * Don't render transient blocks if the block is
         * not the last block
         */
        if (
          block.display === WiseOwlBlockDisplayType.Transient &&
          index !== blocks.length - 1
        ) {
          return <></>;
        }

        return (
          <Box
            key={`${block.type}-${index}`}
            paddingLeft={
              block.type === WiseOwlBlockType.Message ||
              block.type === WiseOwlBlockType.PromptSuggestionGroup
                ? "space0"
                : "space120"
            }
          >
            <Box marginBottom="space30"> {getRendererForBlock(block)}</Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default BlockRenderer;
